import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownBanner() {
  // Start at 14:42 (882 seconds)
  const [timeLeft, setTimeLeft] = useState(882);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 shadow-md" data-id="element-30">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center text-sm md:text-base font-bold tracking-wide text-center gap-2 md:gap-4" data-id="element-31">
        <div className="flex items-center gap-2" data-id="element-32">
          <ClockIcon className="w-5 h-5 animate-pulse" data-id="element-33" />
          <span data-id="element-34">⏰ OFERTA EXPIRA EN:</span>
          <span className="font-mono text-lg bg-red-800 px-2 py-0.5 rounded shadow-inner" data-id="element-35">
            {formatTime(timeLeft)}
          </span>
        </div>
        <span className="hidden md:inline text-red-300" data-id="element-36">|</span>
        <span className="bg-yellow-400 text-red-900 px-3 py-0.5 rounded-full text-xs md:text-sm uppercase animate-pulse" data-id="element-37">
          SOLO QUEDAN 5 CUPOS
        </span>
      </div>
    </div>;
}